import { Box } from '@mui/material'
import { PADDING_BASE } from '../../assets/Styles'
import TopSideBar from '../../components/TopSideBar'
import PageContainer from '../../components/common/PageContainer'
import { Link, useParams } from 'react-router-dom'
import CompanyView from '../../components/CompanyView'
import Breadcrumbs from '../../components/common/Breadcrumbs'
import { useProject } from '../../context/ProjectContext'


export default function CompanyViewPage({ setBlockScreen, setSuccessMessage }: any) {
  const { isProjectUndefined } = useProject()
  const params = useParams<{ company_code?: string }>()
  const company_code = params.company_code ?? ''

  return (<>
    <TopSideBar currentSection='companies' disableProjectSelector />
    <PageContainer>

      <Box paddingBottom={PADDING_BASE}>
        <Breadcrumbs pathlist={[
          <Link className='breadcrumbs-nav__link' to="/tickets/listing">
            Home
          </Link>,
          <Link className='breadcrumbs-nav__link' to="/companies/listing">
            Compañías
          </Link>,
          'Detalle']}
        />
      </Box>

      {!isProjectUndefined() && (
        <CompanyView
          company_code={company_code}
          setBlockScreen={setBlockScreen}
          setSuccessMessage={setSuccessMessage}
        />)}
        
    </PageContainer>
  </>)
}
